import React from "react";
import { useTranslation } from "react-i18next";

export default function BlogHead({ item }) {
  const { t } = useTranslation();
  return (
    <div className="blog-head">
      <p className="set-Audiowide-font">{t(item.title)}</p>
      <p>{`${t("Date")}: ${item.createdDate}`}</p>
    </div>
  );
}
